/**
 * Componente de indicador de status offline
 * Mostra status de conexão e sincronização
 */

import React from 'react';
import { Wifi, WifiOff, RefreshCw, Cloud, CloudOff } from 'lucide-react';

const OfflineIndicator = ({ online, syncing, pendingCount, onSync }) => {
  if (online && pendingCount === 0 && !syncing) {
    // Conectado e sincronizado - não mostrar nada
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 z-50">
      {/* Status de conexão */}
      {!online && (
        <div className="bg-orange-500/90 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2 mb-2 animate-pulse">
          <WifiOff size={18} />
          <span className="text-sm font-medium">Modo Offline</span>
        </div>
      )}

      {/* Itens pendentes de sync */}
      {pendingCount > 0 && (
        <button
          onClick={onSync}
          disabled={!online || syncing}
          className={`
            flex items-center gap-2 px-4 py-2 rounded-lg shadow-lg text-sm font-medium
            ${online 
              ? 'bg-blue-500 hover:bg-blue-600 text-white cursor-pointer' 
              : 'bg-gray-700 text-gray-300 cursor-not-allowed'
            }
          `}
        >
          {syncing ? (
            <RefreshCw size={18} className="animate-spin" />
          ) : online ? (
            <Cloud size={18} />
          ) : (
            <CloudOff size={18} />
          )}
          <span>
            {syncing 
              ? 'Sincronizando...' 
              : `${pendingCount} pendente${pendingCount > 1 ? 's' : ''}`
            }
          </span>
        </button>
      )}

      {/* Sincronizando sem pendentes */}
      {syncing && pendingCount === 0 && (
        <div className="bg-blue-500 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2">
          <RefreshCw size={18} className="animate-spin" />
          <span className="text-sm font-medium">Atualizando dados...</span>
        </div>
      )}
    </div>
  );
};

export default OfflineIndicator;
